/**
 * Forthbridge Clinical Document
 * Forthbridge Clinical Document API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchTargetWithOptionalEntityDto } from './searchTargetWithOptionalEntityDto';


export interface SearchByTargetsRequestDto { 
    /**
     * Array of targets to search for. Unlike search-by-subjects, the entity field is optional - allowing search by target ID alone.
     */
    targets: Array<SearchTargetWithOptionalEntityDto>;
    /**
     * Filter by document reference statuses
     */
    statuses?: Array<SearchByTargetsRequestDto.StatusesEnum>;
    /**
     * Filter by document type IDs
     */
    documentTypeIds?: Array<string>;
    /**
     * Number of items to return
     */
    limit?: number;
    /**
     * Number of items to skip
     */
    offset?: number;
    /**
     * If true, returns all relationships for each document. If false, returns only the relationships that match the target criteria.
     */
    includeAllRelationships?: boolean;
    /**
     * Expand document type details
     */
    expandDocumentType?: boolean;
    /**
     * Expand groups that the document type belongs to (requires expandDocumentType=true)
     */
    expandGroups?: boolean;
}
export namespace SearchByTargetsRequestDto {
    export type StatusesEnum = 'open' | 'closed' | 'on_hold';
    export const StatusesEnum = {
        Open: 'open' as StatusesEnum,
        Closed: 'closed' as StatusesEnum,
        OnHold: 'on_hold' as StatusesEnum
    };
}


